document.addEventListener('DOMContentLoaded', function () {
  var headerWrapper = document.querySelector('.header-wrapper--transparent');
  if (!headerWrapper) return;

  var main = document.getElementById('MainContent');
  var heroSection = main ? main.querySelector('.shopify-section') : null;

  function getThreshold() {
    if (heroSection) {
      return Math.max(heroSection.offsetHeight - headerWrapper.offsetHeight, 0);
    }
    return window.innerHeight * 0.8;
  }

  function onScroll() {
    if (window.scrollY > getThreshold()) {
      headerWrapper.classList.add('is-scrolled');
    } else {
      headerWrapper.classList.remove('is-scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
});
